export { Location } from './location.service';
export { LocationModule } from './location.module';
